/** 관문 칸 오른쪽 위의 「New N」. 0 이면 아무것도 그리지 않는다. 칸(부모)이 `relative` 여야 한다. */
export function NewBadge({ n }: { n: number }) {
  if (n <= 0) return null;
  return (
    <span
      className="pointer-events-none absolute right-2 top-2 z-10 rounded-full px-2.5 py-0.5 text-ui-xs font-bold shadow"
      style={{ background: '#dc2626', color: '#fff' }}
      aria-label={`새 소식 ${n}건`}
    >
      New {n > 99 ? '99+' : n}
    </span>
  );
}
